module.exports = __webpack_public_path__ + "img/1792485662757.6e704e3e.png";